var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardContainer',{attrs:{"list":_vm.products}})
}
var staticRenderFns = []

export { render, staticRenderFns }